// extracted by mini-css-extract-plugin
module.exports = {"page":"Rule_page__PxcfJ"};